import { render, staticRenderFns } from "./wordart.vue?vue&type=template&id=0af986d8&"
import script from "./wordart.vue?vue&type=script&lang=js&"
export * from "./wordart.vue?vue&type=script&lang=js&"
import style0 from "./wordart.vue?vue&type=style&index=0&id=0af986d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.0_m252fu66fivcrdajfhoxhvxrne/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports